import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Form } from 'luna-react';

import Filter from './Filter';

function Header({ children }) {
  return (
    <header className="table-filters--header">
      {children}
    </header>
  );
}

class Body extends Component {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    const { children } = this.props;
    return (
      <section className="table-filters--body">
        {children}
      </section>
    );
  }
}

function Footer({ children }) {
  return (
    <footer className="table-filters--footer">
      {children}
    </footer>
  );
}

function noop() {
}

Panel.propTypes = {
  filters: PropTypes.array,
  isVisible: PropTypes.bool,
  keepVisible: PropTypes.bool,
  itemsCount: PropTypes.objectOf(PropTypes.number),
  trackChange: PropTypes.func,
  onCancel: PropTypes.func,
  onReset: PropTypes.func,
  onApply: PropTypes.func,
};

export default function Panel({
  filters = [],
  autoApply = false,
  isVisible = false,
  keepVisible = false,
  itemsCount = {
    current: 1,
    total: 10,
  },
  onCancel = noop,
  onReset = noop,
  onChange = noop,
  onApply = noop,
  trackChange = noop,
  children,
}) {
  const formClassNames = [];
  const wrapperClassNames = [];

  if (!isVisible) {
    formClassNames.push('is-hidden');
  } else {
    wrapperClassNames.push('is-form-visible');
  }

  if (keepVisible) {
    formClassNames.push('is-visible@m');
  }

  if (autoApply) {
    formClassNames.push('is-autosubmit');
  }

  return (
    <aside className={wrapperClassNames}>
      { children }
      <Form onSubmit={onApply} onChange={onChange} onReset={onReset} className={formClassNames.join(' ')} id="filters">
        <Header>
          <Button label="Back" onClick={onCancel} />
          <span className="table-filters--counter">
            Showing <strong>{itemsCount.current}</strong> of <strong>{itemsCount.total}</strong> items
          </span>
          <Button label="Reset all" type="reset" />
        </Header>

        <Body>
          <p>Set the options from below in order to filter data.</p>
          {filters.map((filter, idx) => <Filter {...filter} autoApply={autoApply} onApply={onApply} trackChange={trackChange} key={idx} /> )}
        </Body>

        <Footer>
          <Button
            label="Apply"
            classNames="luna-button--action"
            type="submit"
          />
          <Button label="Reset all" type="reset" />
          <span className="table-filters--counter">
            Showing <strong className="currentItemCount">{itemsCount.current}</strong> of <strong>{itemsCount.total}</strong> items
          </span>
        </Footer>
      </Form>
    </aside>
  )
}



// WEBPACK FOOTER //
// ./src/components/Panel.js